export const BallsSectionSkeleton = () => {
	return (
		<div className="w-[320px] animate-pulse pt-4 md:pt-6">
			<div className="flex flex-col rounded-2xl border border-gray-200 bg-white pb-2">
				<div className="flex items-center justify-between rounded-t-2xl border-b border-gray-200 px-4 py-3">
					<div className="h-5 w-32 rounded bg-gray-200" />
					<div className="h-5 w-24 rounded bg-gray-200" />
				</div>
				<div className="h-[312px] w-full border-b border-gray-200 bg-gray-100" />
				<div className="flex flex-col gap-4 px-3 pt-4">
					<div className="h-4 w-3/4 rounded bg-gray-200" />
					<div className="flex items-center justify-between">
						<div className="h-4 w-1/4 rounded bg-gray-200" />
						<div className="h-6 w-20 rounded-lg bg-gray-200" />
					</div>
				</div>
			</div>
		</div>
	);
};
